export type LastSaveLabelKind =
  | "seconds"
  | "minute"
  | "minutes"
  | "hour"
  | "hours"
  | "day"
  | "days"
  | "onDate";

export type LastSaveLabelResult =
  | { kind: Exclude<LastSaveLabelKind, "onDate">; count?: number }
  | { kind: "onDate"; dateFormatted: string };

const MS_PER_MINUTE = 60 * 1000;
const MS_PER_HOUR = 60 * MS_PER_MINUTE;
const MS_PER_DAY = 24 * MS_PER_HOUR;
const DAYS_ABSOLUTE_THRESHOLD = 8;

const FR_DATE_FORMAT: Intl.DateTimeFormatOptions = {
  day: "numeric",
  month: "long",
  year: "numeric",
};

export function getLastSaveLabel(
  lastModificationIso: string | null | undefined
): LastSaveLabelResult | null {
  if (!lastModificationIso?.trim()) return null;

  const then = new Date(lastModificationIso);
  if (Number.isNaN(then.getTime())) return null;

  const now = new Date();
  const diffMs = now.getTime() - then.getTime();

  if (diffMs < 0) return null;

  const diffMinutes = Math.floor(diffMs / MS_PER_MINUTE);
  const diffHours = Math.floor(diffMs / MS_PER_HOUR);
  const diffDays = Math.floor(diffMs / MS_PER_DAY);

  if (diffMinutes < 1) {
    return { kind: "seconds" };
  }
  if (diffMinutes < 60) {
    return diffMinutes === 1 ? { kind: "minute" } : { kind: "minutes", count: diffMinutes };
  }
  if (diffHours < 24) {
    return diffHours === 1 ? { kind: "hour" } : { kind: "hours", count: diffHours };
  }
  if (diffDays < DAYS_ABSOLUTE_THRESHOLD) {
    return diffDays === 1 ? { kind: "day" } : { kind: "days", count: diffDays };
  }

  const dateFormatted = then.toLocaleDateString("fr-FR", FR_DATE_FORMAT);
  return { kind: "onDate", dateFormatted };
}
